import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e1fd26c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-select-top el-card" }
const _hoisted_2 = { class: "main-info" }
const _hoisted_3 = { class: "logo-wrap" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "service-name" }
const _hoisted_6 = { class: "system-type" }
const _hoisted_7 = { class: "other-info" }
const _hoisted_8 = { class: "info-item" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = {
  key: 0,
  class: "cm-align-center"
}
const _hoisted_11 = {
  key: 1,
  class: "cm-align-center"
}
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = {
  key: 0,
  style: {"font-size":"16px"}
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "info-item" }
const _hoisted_19 = { class: "label cm-align-center" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  class: "cm-link-light",
  href: "/help/subscribe-help",
  target: "_blank"
}
const _hoisted_22 = { style: {"color":"var(--cm-color-text-secondary)"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_TerminalAuth = _resolveComponent("TerminalAuth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_TerminalAuth, {
    ref: "terminalSelectNode",
    "model-value": _ctx.modelValue,
    title: _ctx.drawerTitle,
    "terminal-api-url": "/permission_service/terminal_list",
    "permission-names": [_ctx.serviceInfo.permission_name],
    "terminal-type": _ctx.serviceInfo.support_system_types,
    onClose: _ctx.handleClose
  }, {
    top: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.serviceInfo.logo || require('@/views/dashboard/service/_images/service-default-logo.png'),
              alt: ""
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_tooltip, {
              content: _ctx.serviceInfo.display_name,
              effect: "light",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.serviceInfo.display_name), 1)
              ]),
              _: 1
            }, 8, ["content"]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('serviceAuth.applicablePrefix')) + _toDisplayString(_ctx.serviceInfo.support_system_types?.map(v => _ctx.TerminalTypeLabel[v]).join('/')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('serviceAuth.subscribeStatus')), 1),
            (_ctx.serviceInfo.type === _ctx.ServiceType.experience)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_CmSvgIcon, {
                    name: _ctx.ServiceStatusIcon[_ctx.ServiceStatus.trying],
                    size: 14,
                    monochrome: "",
                    class: "cm-ui-mr5"
                  }, null, 8, ["name"]),
                  _createElementVNode("span", {
                    style: _normalizeStyle({color: _ctx.ServiceStatusColor[_ctx.ServiceStatus.trying], fontSize: '16px'})
                  }, _toDisplayString(_ctx.ServiceStatusLabel[_ctx.ServiceStatus.trying]), 5)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_CmSvgIcon, {
                    name: _ctx.ServiceStatusIcon[_ctx.serviceInfo.status],
                    size: 14,
                    monochrome: "",
                    class: "cm-ui-mr5"
                  }, null, 8, ["name"]),
                  _createElementVNode("span", {
                    style: _normalizeStyle({color: _ctx.ServiceStatusColor[_ctx.serviceInfo.status], fontSize: '16px'})
                  }, _toDisplayString(_ctx.ServiceStatusLabel[_ctx.serviceInfo.status]), 5)
                ]))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('serviceAuth.subscribeQuantity')), 1),
            (_ctx.serviceInfo.type === _ctx.ServiceType.experience)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('serviceAuth.unlimited')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("em", null, _toDisplayString(_ctx.serviceInfo.terminal_count), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('serviceAuth.unitTerminal')), 1)
                ]))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('serviceAuth.configuredQuantity')), 1),
            _createElementVNode("div", null, [
              _createElementVNode("em", null, _toDisplayString(_ctx.serviceInfo.count), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('serviceAuth.unitTerminal')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('serviceAuth.serviceValidity')) + " ", 1),
              _createVNode(_component_el_tooltip, {
                placement: "top",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('serviceAuth.validityTooltipLine1')), 1),
                  (!_ctx.hideSubscribe)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createTextVNode(_toDisplayString(_ctx.$t('serviceAuth.validityTooltipSee')) + " ", 1),
                        _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.$t('serviceAuth.buyHelpLink')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("i", null, [
                    _createVNode(_component_CmSvgIcon, {
                      name: "assets/icons/warn-border-gray",
                      monochrome: "",
                      size: 18
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("em", null, _toDisplayString(_ctx.serviceInfo.expires_days), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('serviceAuth.unitDay')), 1),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('serviceAuth.expiresUntil', { date: _ctx.formatTimeStamp(_ctx.serviceInfo.expires_time_stamp, 'YYYY-MM-DD') })), 1)
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.isLoading]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title", "permission-names", "terminal-type", "onClose"]))
}